'use client'
import { useEffect } from "react"
import { ensureDeviceId } from "@/util/deviceInfo"
import { runWhenQuiet } from "@/util/dom"

/**
 * 应用启动时生成并持久化设备 id（ThumbmarkJS 指纹，可复现）。
 * 详见 util/deviceInfo.ts 的 ensureDeviceId。
 * 指纹计算（canvas/webgl/字体测量）在低端机上是数百毫秒的长任务，
 * 且新访客每次首访都会触发，因此等页面加载完、用户暂停操作时再执行。
 */
export function DeviceIdInit() {
  useEffect(() => runWhenQuiet(ensureDeviceId), [])

  return null
}
